import { on, off } from 'delegated-events'
import { slideDown, slideToggle, slideUp } from '../common/slide'

const fn = {
    init: () => {
        off('click', '.category-accordion__toggle', fn.handleToggle)
        off('click', '.category-accordion__header--main', fn.handleHeaderClick)
        off('click', '.category-accordion__header--sub', fn.handleHeaderClick)
        off('click', '.category-accordion__open-all', fn.handleOpenAll)
        on('click', '.category-accordion__toggle', fn.handleToggle)
        on('click', '.category-accordion__header--main', fn.handleHeaderClick)
        on('click', '.category-accordion__header--sub', fn.handleHeaderClick)
        on('click', '.category-accordion__open-all', fn.handleOpenAll)
    },

    handleToggle: (e) => {
        e.preventDefault()
        fn.toggleItem(e.currentTarget)
    },

    handleHeaderClick: (e) => {
        if (e.target.closest('input, label, a, button')) {
            return
        }

        const header = e.currentTarget
        const toggle = header.querySelector('.category-accordion__toggle')

        if (toggle) {
            fn.toggleItem(toggle)
        }
    },

    setToggleOpen: (toggle) => {
        toggle.classList.remove('closed')
        toggle.setAttribute('aria-expanded', 'true')

        const showText = toggle.querySelector('.show-text')
        const hideText = toggle.querySelector('.hide-text')
        const icon = toggle.querySelector('svg, img')

        if (showText) showText.classList.add('hidden')
        if (hideText) hideText.classList.remove('hidden')
        if (icon) icon.classList.add('rotate-180')
    },

    setToggleClosed: (toggle) => {
        toggle.classList.add('closed')
        toggle.setAttribute('aria-expanded', 'false')

        const showText = toggle.querySelector('.show-text')
        const hideText = toggle.querySelector('.hide-text')
        const icon = toggle.querySelector('svg, img')

        if (showText) showText.classList.remove('hidden')
        if (hideText) hideText.classList.add('hidden')
        if (icon) icon.classList.remove('rotate-180')
    },

    toggleItem: (toggle) => {
        const item = toggle.closest('.category-accordion__item')
        const content = item.querySelector('.category-accordion__content')

        if (!content) {
            return
        }

        if (toggle.classList.contains('closed')) {
            fn.setToggleOpen(toggle)
        } else {
            fn.setToggleClosed(toggle)
        }

        slideToggle(content)
    },

    handleOpenAll: (e) => {
        e.preventDefault()
        const openAll = e.currentTarget
        const accordion = openAll.closest('.category-list-form').querySelector('.category-accordion')

        if (!accordion) {
            return
        }

        const closeAll = openAll.classList.contains('is-active')
        const showText = openAll.querySelector('.show-text')
        const hideText = openAll.querySelector('.hide-text')

        if (closeAll) {
            accordion.querySelectorAll('.category-accordion__toggle:not(.closed)').forEach((toggle) => {
                const item = toggle.closest('.category-accordion__item')
                const content = item.querySelector('.category-accordion__content')

                fn.setToggleClosed(toggle)

                if (content) {
                    slideUp(content)
                }
            })

            openAll.classList.remove('is-active')
            if (showText) showText.classList.remove('hidden')
            if (hideText) hideText.classList.add('hidden')
        } else {
            accordion.querySelectorAll('.category-accordion__toggle.closed').forEach((toggle) => {
                const item = toggle.closest('.category-accordion__item')
                const content = item.querySelector('.category-accordion__content')

                fn.setToggleOpen(toggle)

                if (content) {
                    slideDown(content)
                }
            })

            openAll.classList.add('is-active')
            if (showText) showText.classList.add('hidden')
            if (hideText) hideText.classList.remove('hidden')
        }
    }
}

export default {
    can: () => document.querySelector('.category-accordion'),
    run: fn.init,
}
